import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { LoginService } from '../security/login.service';

@Component({
  selector: 'app-contact-request-quotation-preview',
  templateUrl: './contact-request-quotation-preview.component.html',
  styleUrls: ['./contact-request-quotation-preview.component.css']
})
export class ContactRequestQuotationPreviewComponent implements OnInit {
  
  htmlString!: SafeResourceUrl;
  cssString: string = "{'background-color': 'red'}";
  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private loginService: LoginService,
    private domSanitizer: DomSanitizer
  ) { 
    this.loginService.activatedNavigationComponent = false;
  }

  ngOnInit(): void {
    let quotationId = Number(this.route.snapshot.paramMap.get("quotationId"));
    let language = this.route.snapshot.paramMap.get("language");
    this.httpService.getContactRequestQuotationPreview(quotationId, language!).subscribe(res => {
      this.htmlString = this.domSanitizer.bypassSecurityTrustHtml(res);;
    });
  }

}
